import {NOTIFICATION_SETTINGS} from './../constants/globalConstants';

const generatePassword = (length, chars) => {
  let password = '';
  let c, k;
  if (typeof window.crypto.getRandomValues === 'function' || typeof window.msCrypto.getRandomValues === 'function') {
    const crypto = window.crypto || window.msCrypto; // for IE 11
    const array = new Uint16Array(length);
    crypto.getRandomValues(array);
    for (var i = 0; i < length; i++) {
      k = Math.floor((array[i] / Math.pow(2, 16)) * chars.length);
      c = chars[k];
      password += c;
    }
    return password;
  } else {
    this.$snotify.error('Error generating password', '', NOTIFICATION_SETTINGS);
  }
};

export default generatePassword;
